<template>
    <v-file-input
        v-model="file"
        clearable
        density="compact"
        variant="outlined"
        color="primary"
        data-cy="document"
        :label="$t('document')"
        truncate-length="20"
        show-size
        @update:model-value="addDocument()"
    />
    <v-data-table-server
        v-if="documents?.length"
        :headers="useHeaders"
        :items="documents"
        :items-per-page="-1"
        :items-per-page-options="[-1]"
        hide-default-footer
        :loading="isLoading"
        :items-length="documents.length"
        disable-sort
        density="compact"
        color="primary"
        class="elevation-1"
        data-cy="table"
    >
        <template v-slot:item.name="{item}">
            <div
                v-if="item.id"
                class="text-subtitle-2 text-link"
                :data-cy="`download-${item.id}`"
                @click="downloadDocument(item)"
            >
                {{ item.name }}
            </div>
            <div v-else>
                {{ item.name }}
            </div>
        </template>
        <template v-slot:item.action="{item}">
            <v-btn
                variant="text"
                :color="item?.toDelete ? 'error' : 'primary'"
                class="mr-4 text-caption"
                :data-cy="`delete-${item.id}`"
                density="compact"
                @click="deleteDocument(item)"
            >
                {{ item?.toDelete ? $t('restore') : $t('delete') }}
            </v-btn>
        </template>
    </v-data-table-server>
</template>

<script setup lang="ts">
    import {fullUrl} from '~/utils/host-adapter'
    import {downloadDataAsync} from '@/utils/helpers'

    const documents = defineModel<any>()

    const isLoading = ref<boolean>(false)
    const file = ref(null)

    const {t} = useI18n()

    const deleteDocument = async file => {
        if (file?.id) {
            file.toDelete = !file.toDelete
        } else documents.value = documents.value.filter(({name}) => name !== file.name)
    }

    const useHeaders = computed(() => {
        return [
            {title: t('name'), value: 'name'},
            {title: '', value: 'action', minWidth: '140px', width: '30%', align: 'end'},
        ]
    })

    const downloadDocument = async doc => {
        const url = fullUrl(`/files/${doc.url}`)
        await downloadDataAsync(url, doc.name)
    }

    const addDocument = () => {
        if (file.value) {
            if (Array.isArray(file.value)) {
                documents.value.push(...file.value)
            } else {
                documents.value.push(file.value)
            }
            file.value = null
        }
    }
</script>
